export enum PLATFORM_TYPES {
  NYKAA_BEAUTY,
  NYKAA_MAN,
}
